module.exports = "<p-toast key=\"global\" [style]=\"{marginTop: '80px'}\" [baseZIndex]=\"5000\"></p-toast>\r\n\r\n<div class=\"w-100\">\r\n  <p-blockUI [blocked]=\"loading\" >\r\n    <i class=\"pi pi-spin pi-spinner\" style=\"font-size: 5em; margin-top: 280px\" ></i>\r\n  </p-blockUI>\r\n\r\n  <svc-header *ngIf=\"router.url != '/login' && auth.isLogin()\"></svc-header>\r\n    <router-outlet></router-outlet>\r\n  <svc-footer *ngIf=\"router.url != '/login' && auth.isLogin()\"></svc-footer>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main